import { axiosGet, axiosPost } from "../../react_axios/Axios"
import {
    getEnquiryListUrl, GET_ENQUIRY_LIST_ACTION, getEnquiryDetailsUrl, GET_ENQUIRY_DETAILS,
    headers
} from "../../utils/constants"

export const getEnquiryList_action = (CompanyName, EmailAddress) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            CompanyName: CompanyName,
            EmailAddress: EmailAddress
        }

        const res = await axiosGet(getEnquiryListUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_ENQUIRY_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const getEnquiryDetails_action = (EnquiryID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            EnquiryID: EnquiryID
        }

        const res = await axiosGet(getEnquiryDetailsUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_ENQUIRY_DETAILS,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
